import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useRecoilValue } from 'recoil';
import { LocaleContext } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { SummarySection } from '@zurich/ui/legacy/components';
import { PremiumUtils } from '@zurich-client/typeutils/contract';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
export function PolicyDetailPremiumSummary() {
    const { t } = useTranslation();
    const locale = useContext(LocaleContext);
    const offer = useRecoilValue(offerDetailsAtom);
    const premiumData = [
        {
            label: t('policy.grossPremium'),
            value: PremiumUtils.formatValue(offer.premium?.annualGrossPremium, locale),
        },
        {
            label: t('policy.paymentMethod'),
            value: offer.paymentInterval &&
                t([
                    `policy.payment_interval.${offer.paymentInterval.toLocaleLowerCase()}`,
                ]),
        },
        {
            label: t('policy.generalDetailPaymentWay'),
            value: offer.paymentWay &&
                t([`policy.payment_way.${offer.paymentWay}`, offer.paymentWay]),
        },
        // TODO: add entry for Index
    ];
    if (offer.paymentWay === 'KKI') {
        premiumData.push({
            label: t('policy.kkiAccountNo'),
            value: offer?.kkiAccountNo,
        });
    }
    return (_jsx(SummarySection, { rows: premiumData, title: t('policy.premium'), editable: false }));
}
